import { render, staticRenderFns } from "./EventDate.vue?vue&type=template&id=2d0dd6c5&scoped=true&"
import script from "./EventDate.vue?vue&type=script&lang=js&"
export * from "./EventDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0dd6c5",
  null
  
)

export default component.exports